export const MenuItems = [
    {
        title: "Baseball",
        group: "Baseball",
        url: "/Baseball"
    },
    {
        title: "Basketball",
        group: "Basketball",
        url: "/Basketball"
    },
    {
        title: "Am. Football",
        group: "American Football",
        url: "/American Football"
    },
    {
        title: "Golf",
        group: "Golf",
        url: "/Golf"
    },
    {
        title: "Soccer",
        group: "Soccer",
        url: "/Soccer"
    },
    // {
    //     title: "Tennis",
    //     group: "Tennis",
    //     url: "/Tennis"
    // }
];